import { IWidgetWithErrors, DataWidgetBase } from '.';
import { WideError } from '../../common';

export class WidgetWithErrors extends DataWidgetBase implements IWidgetWithErrors {
    private _error: WideError;

    getError(): WideError {
        return this._error;
    }

    setError(error: WideError): void {
        this._error = error;
    }
}